import { Injectable } from '@angular/core';
import {Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions} from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';

import { StorageService } from '../../shared/services/storage.service';
import { ErrorService } from '../../shared/services/error.service';
import { PopupService } from '../../shared/services/pop-up.service';

@Injectable()
export class AdminService{

    vTotalData: number = 0;

    vIsEditable: boolean;
    vLoadingStatus: boolean;
    
    vUserLists: Array<{
        user_record_id: number,
        email: string,
        create_date: string,
        description: string,
        company_name: string
    }>;

    vCreateAccountData : {
        email: string,
        retype_email: string,
        first_name: string,
        last_name: string,
        company_reg_no: string,
        phone_no: string,
        company_name: string,
        designation: string,
        address_line_1: string,
        address_line_2: string,
        building_name: string,
        postal_code: string,
        role_record_id: number
    }

    vUserDetailsData : {
        user_record_id: number,
        role_record_id: number,
        email: string,
        first_name: string,
        last_name: string,
        company_reg_no: string,
        phone_no: string,
        company_name: string,
        designation: string,
        address_line_1: string,
        address_line_2: string,
        building_name: string,
        postal_code: string,
        description: string
    }

    vResetUserData : {
        email: string,
        confirmation_code: string
    }

    vInternalRoles: Array<{
        role_record_id: number,
        role_id: string,
        description: string,
    }>;

    vAllRoles: Array<{
        role_record_id: number,
        role_id: string,
        description: string,
    }>;

    constructor(
        private _http: Http,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _popupService: PopupService
    ) {
        this.vLoadingStatus = false;
    }

    getCreateAccountData(){
        return this.vCreateAccountData;
    }

    getUserDetailsData(){
        return this.vUserDetailsData;
    }

    getTotalData(){
        return this.vTotalData;
    }

    getUsersList(){
        return this.vUserLists;
    }

    getResetUserData(){
        return this.vResetUserData;
    }

    getInternalRoles(){
        return this.vInternalRoles;
    }

    getAllRoles(){
        return this.vAllRoles;
    }

    isUserEditable(){
        return this.vIsEditable;
    }

    isLoading(){
        return this.vLoadingStatus;
    }

    resetCreateAccountData(){
        this.vCreateAccountData = {
            email: "",
            retype_email: "",
            first_name: "",
            last_name: "",
            company_reg_no: "",
            phone_no: "",
            company_name: "",
            designation: "",
            address_line_1: "",
            address_line_2: "",
            building_name: "",
            postal_code: "",
            role_record_id: 0
        }
    }

    resetUserDetailsData(){
        this.vUserDetailsData = {
            user_record_id: 0,
            role_record_id: 0,
            email: "",
            first_name: "",
            last_name: "",
            company_reg_no: "",
            phone_no: "",
            company_name: "",
            designation: "",
            address_line_1: "",
            address_line_2: "",
            building_name: "",
            postal_code: "",
            description: ""
        }
    }

    resetResetUserData(){
        this.vResetUserData = {
            email : '',
            confirmation_code: ''
        }
    }

    resetError() {
        this._errorService.resetErrorFlag();
        this._errorService.resetError();
        this._errorService.resetBackEndError();
    }

     validateCreateAccountInput(){
        if(!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.vCreateAccountData.email)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('email', 'Email Address provided is not valid');
        }
        if(this.vCreateAccountData.email !== this.vCreateAccountData.retype_email){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('retypeEmail', 'Retype email must be the same with email');
        }
        if(!/^\+?\d+$/.test(this.vCreateAccountData.phone_no)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('phoneNo', 'Phone number provided is not valid');
        }
        if(!/^[0-9]+$/.test(this.vCreateAccountData.postal_code)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('postalCode', 'Postal code provided is not valid');
        }
    }

    isDisableCreateAccount(){
        if(this.vCreateAccountData.role_record_id === undefined || this.vCreateAccountData.role_record_id === 0){
            return true;
        }
        else if(this.vCreateAccountData.email === undefined || this.vCreateAccountData.email === ''){
            return true;
        }
        else if(this.vCreateAccountData.retype_email === undefined || this.vCreateAccountData.retype_email === ''){
            return true;
        }
        else if(this.vCreateAccountData.first_name === undefined || this.vCreateAccountData.first_name === ''){
            return true;
        }
        else if(this.vCreateAccountData.last_name === undefined || this.vCreateAccountData.last_name === ''){
            return true;
        }
        else if(this.vCreateAccountData.company_reg_no === undefined || this.vCreateAccountData.company_reg_no === ''){
            return true;
        }
        else if(this.vCreateAccountData.phone_no === undefined || this.vCreateAccountData.phone_no === ''){
            return true;
        }
        else if(this.vCreateAccountData.company_name === undefined || this.vCreateAccountData.company_name === ''){
            return true;
        }
        else if(this.vCreateAccountData.designation === undefined || this.vCreateAccountData.designation === ''){
            return true;
        }
        else if(this.vCreateAccountData.address_line_1 === undefined || this.vCreateAccountData.address_line_1 === ''){
            return true;
        }
        else if(this.vCreateAccountData.postal_code === undefined || this.vCreateAccountData.postal_code === ''){
            return true;
        }
        return false;
    }

    isDisableConfirmResetUser(){
        return (this.vResetUserData.confirmation_code === '' || this.vResetUserData.confirmation_code === undefined);
    }

    loadAllUserRoles(){
        let data = this._storageService.getSessionItem('allRoles');
        if(data !== null){
            this.vAllRoles = JSON.parse(data);
        } else {
            this._http.get(API_ENDPOINTS.ADMIN.GET_ALL_ROLES).subscribe(
                (response) => {
                    let vResponseData:any = response;
                    console.log(vResponseData);
                    this.vAllRoles = vResponseData.data;
                    this._storageService.setSessionItem('allRoles', JSON.stringify(this.vAllRoles));
                },
                (error) => {
                    let vErrorData = error;
                    console.log(error);
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            );
        }
    }

    loadUsers(pPageNumber, pPageSize, pEmail, pUserRole){
        var promise = this._http.get(API_ENDPOINTS.ADMIN.GET_ALL_USER + '?page_number=' + pPageNumber + '&page_size=' + pPageSize+'&email='+pEmail+'&role_record_id='+pUserRole);

        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vUserLists = vResponseData.data.users;
                resolve();
            },
            (error)  => {
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    loadUsersFilterBy(pPageNumber, pPageSize, pSearchBy, pFilterBy,pUserRole){
        var promise = this._http.get(API_ENDPOINTS.ADMIN.GET_ALL_USER + '?page_number=' + pPageNumber + '&page_size=' + pPageSize+'&search_by='+pSearchBy+'&filter_by='+pFilterBy+'&role_record_id='+pUserRole);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vUserLists = vResponseData.data.users;
                resolve();
            },
            (error)  => {
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    loadTotalData(pEmail, pUserRole){
        var promise = this._http.get(API_ENDPOINTS.ADMIN.GET_TOTAL_USER + '?email='+pEmail+'&role_record_id='+pUserRole);

        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vTotalData = vResponseData.data.total_users;
                resolve();
            },
            (error)  => {
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    loadTotalCompanyData(pSearchBy, pFilterBy, pUserRole){
        var promise = this._http.get(API_ENDPOINTS.ADMIN.GET_TOTAL_USER + '?search_by='+pSearchBy+'&filter_by='+pFilterBy+'&role_record_id='+pUserRole);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                let vResponseData:any = response;
                this.vTotalData = vResponseData.data.total_users;
                resolve();
            },
            (error)  => {
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    loadUserDetails(pUserid) {
        this.resetError();
        
        this.vLoadingStatus = true;
        this.vIsEditable = false;
        this._http.get(API_ENDPOINTS.ADMIN.GET_USER_PROFILE + '?user_record_id=' + pUserid).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vUserDetailsData = vResponseData.data.user;
                if(vResponseData.data.user.role_type === "Internal"){
                    this.vIsEditable = true;
                }
            },
            (error) => {
                this.vLoadingStatus = false;
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                console.log(error);
            }
        );
    }
    
    loadInternalRoles(){
        let data = this._storageService.getSessionItem('allInternalRoles');
        if(data !== null){
            this.vInternalRoles = JSON.parse(data);
        } else {
            this.vLoadingStatus = true;
            this._http.get(API_ENDPOINTS.ADMIN.GET_INTERNAL_ROLES).subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData:any = response;
                    console.log(vResponseData);
                    this.vInternalRoles = vResponseData.data;
                    this._storageService.setSessionItem('allInternalRoles', JSON.stringify(this.vInternalRoles));
                },
                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            );
        }
    }

    createAccount() {
        this.resetError();
        this.validateCreateAccountInput();

        if(this._errorService.getErrorFlag()){
            this._popupService.openGeneralConfirmationPopup('Notice', 'Some of the required information is invalid or missing. Please correct them before proceeding with the profile update. Thank You.', '', false, false);
            return;
        }

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.ADMIN.CREATE_ACCOUNT, this.vCreateAccountData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this._popupService.openGeneralConfirmationPopup('Notice', 'Account successfully created', '', true, false);
                this.resetCreateAccountData();
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                if(vErrorData.code === 903){
                    this._errorService.setErrorStatusAndMessage('email', 'This email address has already been registered.');
                    this._popupService.openGeneralConfirmationPopup('Notice', 'Some of the required information is invalid or missing. Please correct them before proceeding with the profile update. Thank You.', '', false, false);
                }else if(vErrorData.code === 814){
                    this._popupService.openGeneralConfirmationPopup('Error', 'Create account failed, please try again', '', false, false);
                }else if(vErrorData.code === 815){
                    this._popupService.openGeneralConfirmationPopup('Error', 'Failed to send code to user\'s email', '', false, false);
                }else{
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            }
        );
    }

    resetUserPassword() {
        this.resetError();

        var xData = {
            user_record_id: this.vUserDetailsData.user_record_id
        }

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.ADMIN.RESET_USER_PASSWORD, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this.vResetUserData.email = this.vUserDetailsData.email;
                this.openResetPasswordUserPopup();
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                if(vErrorData.code === 908){
                    this._popupService.openGeneralConfirmationPopup('Notice', 'Attempt limit exceeded, please try again after some time', '', false, false);
                } else if(vErrorData.code === 911){
                    this._popupService.openGeneralConfirmationPopup('Error', 'User is not in confirmed state', '', false, false);
                } else if(vErrorData.code === 819){
                    this._popupService.openGeneralConfirmationPopup('Error', 'Reset user failed', '', false, false);
                } else {
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            }
        );
    }

    openResetPasswordUserPopup(){
        this._popupService.openPopup( 'reset-user', {
            title: 'Reset User Password',
            message: '',
            }
        );
    }

    confirmResetUser(){
        this.resetError();

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.ADMIN.CONFIRM_RESET_PASSWORD, this.vResetUserData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this._popupService.openGeneralConfirmationPopup('Notice', 'User Account successfully reset', '', true, false);
                this.resetResetUserData();
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                if(vErrorData.code === 822){
                    this._popupService.openGeneralConfirmationPopup('Error', 'Confirm reset password failed', '', false, false);
                    this.resetResetUserData();
                } else if(vErrorData.code === 908){
                    this._popupService.openGeneralConfirmationPopup('Notice', 'Attempt limit exceeded, please try again after some time', '', false, false);
                    this.resetResetUserData();
                } else if(vErrorData.code === 825){
                    this._popupService.openGeneralConfirmationPopup('Error', 'Failed to send email to user', '', false, false);
                    this.resetResetUserData();
                } else {
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            }
        );
    }

    updateUser() {
        this.resetError();

        var xData = {
            user_record_id: this.vUserDetailsData.user_record_id, 
            role_record_id: this.vUserDetailsData.role_record_id
        }

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.ADMIN.CHANGE_ROLE, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this._popupService.openGeneralConfirmationPopup('Notice', 'User role successfully changed', '', true, false);
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/admin/services/admin.service.ts